import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18C18.7957 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V18C21 18.7957 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7957 21 18 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7957 3 18V6ZM15.6103 9.41982C15.8511 9.08276 15.773 8.61434 15.4359 8.37359C15.0989 8.13283 14.6305 8.2109 14.3897 8.54796L11.1543 13.0775L9.53033 11.4536C9.23744 11.1607 8.76256 11.1607 8.46967 11.4536C8.17678 11.7465 8.17678 12.2213 8.46967 12.5142L10.7197 14.7642C10.8756 14.9201 11.0921 14.9995 11.3119 14.9813C11.5316 14.9631 11.7322 14.8492 11.8603 14.6698L15.6103 9.41982Z"
        fill={colorValue}
      />
    </svg>
  );
};
